/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { makeAPI } from "@/frameworks/core/API";
import SpaceService from "./api";

//@deprecated
export default function withSpace(events: API.Events) {
	return {
		create: makeAPI<WebServices.Space.Create.Response>(SpaceService.space.create("create", events)),
		update: makeAPI<WebServices.Space.Update.Response>(SpaceService.space.update("update", events)),
		detail: makeAPI<WebServices.Space.Detail.Response>(SpaceService.space.detail("detail", events)),
		delete: makeAPI<WebServices.Space.Delete.Response>(SpaceService.space.deleteSpace("delete", events)),
		checkBeforeParticipate: makeAPI<WebServices.Space.Participate.Response>(
			SpaceService.space.checkBeforeParticipate("checkBeforeParticipate", events)
		),
		enter: makeAPI<WebServices.Space.Participate.Response>(SpaceService.space.enter("enter", events)),
		//@deprecated use beacons instead
		leave: makeAPI<WebServices.Space.Leave.Response>(SpaceService.space.leave("leave", events)),
		authorities: makeAPI<WebServices.Space.Authorities.Response>(
			SpaceService.space.authorities("authorities", events)
		),
		mySpaces: {
			list: makeAPI<WebServices.Space.MySpaces.List.Response>(
				SpaceService.space.mySpaces.list("mySpaces:list", events)
			),
			updateSpaceChatNotification: makeAPI<WebServices.Space.SpaceChatNotification.Response>(
				SpaceService.spaceNotification.UpdateSpaceChatNotification(
					"mySpaces:updateSpaceChatNotification",
					events
				)
			)
		},
		search: {
			...makeAPI<WebServices.Space.Search.Response>(SpaceService.space.search("search", events)),
			allowTypes: makeAPI<WebServices.Space.Search.AllowTypes.Response>(
				SpaceService.space.allowTypes("search:allowTypes", events)
			)
		},
		join: {
			list: makeAPI<WebServices.Space.Join.List.Response>(SpaceService.space.join.list("join:list", events)),
			request: makeAPI<WebServices.Space.Join.Request.Response>(
				SpaceService.space.join.request("join:request", events)
			),
			process: makeAPI<WebServices.Space.Join.Process.Response>(
				SpaceService.space.join.process("join:process", events)
			),
			status: makeAPI<WebServices.Space.Join.Status.Response>(
				SpaceService.space.join.status("join:status", events)
			),
			cancel: makeAPI<WebServices.Space.Join.Cancel.Response>(
				SpaceService.space.join.cancel("join:cancel", events)
			)
		},
		resistExternalGroupUser: makeAPI<WebServices.Space.ResistExternalGroupUser.Response>(
			SpaceService.space.resistExternalGroupUser("resistExternalGroupUser", events)
		),
		inquiryWOAuth: makeAPI<WebServices.Space.InquiryWOAuth.Response>(
			SpaceService.space.inquiryWOAuth("inquiryWOAuth", events)
		),
		actionLog: makeAPI<WebServices.Space.SpaceActionLog.Response>(SpaceService.space.log("actionLog", events))
	};
}
